import { Fragment, type ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { useMe } from '../api/client';

/**
 * Login/logout affordance. `inline` (the header) joins the links with middots in one span;
 * `menu` (the landing menu's Misc column) renders each link and the Log out button as its own
 * block row so the `.menuitems a, .menuitems button` rules apply uniformly.
 */
export function UserBox({ variant = 'inline' }: { variant?: 'inline' | 'menu' }) {
  const me = useMe();
  const location = useLocation();
  const next = encodeURIComponent(location.pathname + location.search);
  const menu = variant === 'menu';
  if (me.isPending) return menu ? null : <span className="user-box muted">&nbsp;</span>;
  const user = me.data?.user ?? null;
  const items: ReactNode[] = [];
  if (!user) {
    items.push(<Link to={`/login?next=${next}`}>Log in</Link>);
  } else {
    items.push(<Link to="/me">{user.battletag}</Link>);
    if (user.role !== 'player') items.push(<Link to="/mod">Queue</Link>);
    if (user.role === 'admin') items.push(<Link to="/admin">Admin</Link>);
    items.push(<LogoutButton plain={menu} />);
  }
  if (menu) {
    return (
      <>
        {items.map((item, i) => (
          <Fragment key={i}>{item}</Fragment>
        ))}
      </>
    );
  }
  return (
    <span className="user-box">
      {items.map((item, i) => (
        <Fragment key={i}>
          {i > 0 && ' · '}
          {item}
        </Fragment>
      ))}
    </span>
  );
}

function LogoutButton({ plain }: { plain: boolean }) {
  return (
    <form
      method="post"
      action="/auth/logout"
      style={plain ? undefined : { display: 'inline' }}
      onSubmit={async (e) => {
        e.preventDefault();
        await fetch('/auth/logout', { method: 'POST', credentials: 'same-origin' });
        window.location.assign('/');
      }}
    >
      <button
        type="submit"
        className={plain ? undefined : 'vote-arrow'}
        style={plain ? undefined : { color: 'var(--link)', textDecoration: 'underline' }}
      >
        Log out
      </button>
    </form>
  );
}
